// apollo client
import { gql } from '@apollo/client';

const DELETE_DEVICE_PROFILE = gql`
  mutation DeleteDeviceProfile($id: String!) {
    deleteDeviceProfile(id: $id) {
      success
      message
    }
  }
`;

export default DELETE_DEVICE_PROFILE;
